'use client';
import styled from 'styled-components';

import Button from '@components/Button';
import { Wrapper as OpportunityCardWrapper } from '@components/cards/opportunity/OpportunityCardStyle';
import { Container as ScrollTabContainer } from '@components/ui/scroll-tab/styled';

export const PageContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
`;

export const Container = styled.div`
  width: 100%;
  height: auto;
  position: relative;
`;

export const TourDetailContainer = styled.div`
  width: 100%;
  height: auto;
  border-radius: 2px;
  color: ${({ theme }) => theme.palette.darkGrey};
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;

  ${OpportunityCardWrapper} {
    border-radius: 8px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    background-color: ${({ theme }) => theme.palette.white};
  }
`;

export const TourOpportunitySection = styled.div`
  width: 100%;

  & > div > div:first-child h2 {
    margin-bottom: 0;
  }

  & > div > div:nth-child(2) {
    margin-top: 16px;
  }
`;

export const TabMenuWrapper = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.grey300}`};
  overflow-x: auto;
  scroll-behavior: smooth;
  margin-top: 60px;
  white-space: nowrap;
  &::-webkit-scrollbar {
    display: none;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-top: 0px;
  }
`;
export const SearchBarWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 1100px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.SMALL})`} {
    width: 100%;
  }
`;

export const TabWrapper = styled.div<{
  visible: boolean;
  top: number;
}>`
  position: fixed;
  top: ${({ visible }) => (visible ? '0' : '-400px')};
  width: 100%;
  height: 81px;
  background: ${({ theme }) => theme.palette.white};
  z-index: 99;
  transition: all 0.35s;
  box-shadow: 0 20px 20px 0 rgba(58, 58, 58, 0.2);

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    border-top: 1px solid ${({ theme }) => theme.palette.lightsSilver};
    top: ${({ visible, top }) => (visible ? `${top - 2}px` : '-400px')};

    ${ScrollTabContainer} {
      justify-content: space-between;

      & a {
        font-size: 13px;
      }
    }
  }
`;

export const Wrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0 12px;
  }
`;

export const ImagesWrapper = styled.div`
  position: relative;
  margin-bottom: -80px;
  z-index: 0;
  object-fit: contain;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  justify-content: center;
  padding: 20px 0 20px 0;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding-top: 0;
    margin: 0;
    padding-bottom: 0px;
  }
`;

export const BreadcrumbWrapper = styled.div`
  width: 100%;
  display: flex;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  padding-top: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    padding-left: 15px;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    height: 50px;
    align-items: center;
    padding: 15px;
    padding-left: 15px;
    display: flex;
    margin-bottom: 0;
    max-width: auto;
  }
`;

export const BreadcrumbWrapperListing = styled.div`
  max-width: 1200px;
  height: auto;
  margin: 0 auto;
  margin-bottom: 20px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 40px;
    align-items: center;
    padding: 15px;
    padding-left: 15px;
    display: flex;
    margin-bottom: 0;
    max-width: auto;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: 15px;
    margin-right: 15px;
  }
`;

export const StyledButton = styled(Button)`
  width: 50vw;
  height: 58px !important;
`;

export const ContainerTour = styled.div`
  height: 100%;
  margin: 40px 0px;
`;

export const ContainerTourMobile = styled.div`
  height: 100%;
  margin-bottom: 10px;
`;

export const Title = styled.span<{ fontSize: number; margin?: number }>`
  font-size: ${({ fontSize }) => fontSize}px;
  font-weight: bold;
  margin-left: ${({ margin }) => (margin ? margin : 0)}px;
`;
